import React from 'react';
import hero from './../../images/hero-lady.jpg';
import { Typography, Grid } from '@mui/material';
import { PrimaryButton } from '../Button';

const Hero = () => {
  return (
    <Grid display={'flex'} justifyContent={'space-around'} flexDirection={'column'} alignItems={'center'} py={4}>
      <Grid size={12} display={'flex'} justifyContent={'center'} my={0}>
        <img src={hero} alt='hero' style={{ width: '90%', height: 'auto', borderRadius: '10%', aspectRatio: 'inherit' }} data-testid="hero-image" />
      </Grid>
      <Grid size={12} mt={{xs: 4, sm: 6}}>
        <Grid size={12}>
          <Typography variant="h2" component="h1" align='center' data-testid="hero-text" sx={{ mb: 3 }} fontSize={{ xs: '2rem', md: '3rem'}}>
            From the washing line<br />
            to the fashion line
          </Typography>
        </Grid>
        <Grid size={12} display={'flex'} justifyContent={'center'}>
          <a href="/products">
              <PrimaryButton>SHOP NOW</PrimaryButton>
          </a>
        </Grid>
      </Grid>
      
    </Grid>
  );
};

export default Hero;